import PolicyMyths from '@components/pages/PolicyMyths';
import {automythTypes} from './MythsAutoTypesData';

const MythsAuto = () => {
  return <PolicyMyths myths={automythTypes} />;
};

export default MythsAuto;
